<template>
  <nav>
    <v-app-bar
      flat
      app
      >
        <v-app-bar-nav-icon
          @click="drawer = !drawer"
        ></v-app-bar-nav-icon>

      <v-toolbar-title class="blue-grey--text">한양 2</v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- referrences -->
      <!-- <div class="d-none d-lg-flex d-xl-flex">
        <v-tooltip bottom v-for="ref in references" :key="ref.title">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" :href="ref.href" target="_blank">
              <v-img width="15" :src="ref.avatar" />
            </v-btn>
          </template>
          <span>{{ref.title}}</span>
        </v-tooltip>
      </div> -->

      <!-- dropdown menu -->
      <!-- <div>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              <v-icon left>mdi-menu-down</v-icon>
              <span>menu</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in items" :key="index" link :to="item.router">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>       -->

      <!-- auth buttons -->
      <v-btn v-if="!user" class="blue-grey--text" text to="/signup">
        <v-icon left>mdi-login-variant</v-icon>
        <span>회원가입</span>        
      </v-btn>
      <v-btn v-if="!user" class="blue-grey--text" text to="/login">
        <v-icon left>mdi-login</v-icon>
        <span>로그인</span>        
      </v-btn>
      <v-btn v-if="user" class="blue-grey--text" text @click="logout">        
        <v-icon left>mdi-logout</v-icon>
        <span>로그아웃</span>
      </v-btn>
      <v-btn v-if="user" class="blue-grey--text" text to="/additem">
        <v-icon left>mdi-playlist-plus</v-icon>
        <span>항목추가</span>
      </v-btn>
    </v-app-bar>

    <!-- sidebar menu -->
    <v-navigation-drawer
      app
      dark
      v-model="drawer"
      class="blue-grey darken-4"
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-img src="https://avatarmaker.net/images/11.png"></v-img>
          </v-list-item-avatar>
        </v-list-item>

        <v-list-item v-if="user" link>
          <v-list-item-content>
            <v-list-item-title>
              {{ user.name }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-icon>mdi-menu-down</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense nav shaped>
        <v-list-item v-for="item in items" :key="item.title" link :to="item.router">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense nav shaped>
        <v-subheader>바로가기</v-subheader>
        <v-list-item v-for="ref in references" :key="ref.title" link :href="ref.href" target="_blank">
          <v-list-item-avatar size="20" tile>
            <v-img :src="ref.avatar"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ ref.title }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-icon small>mdi-open-in-new</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>

    </v-navigation-drawer>
  </nav>
</template>

<script>
import { auth } from '../firebase/init'
import { db } from '../firebase/init'

export default {
  name: 'App',
  data: () => ({
    user: null,
    drawer: false,
    items: [
      { title: '전체보기', icon: 'mdi-home', router: '/'},
      { title: '내것보기', icon: 'mdi-account-outline', router: '/projects' },
      { title: '팀구성원', icon: 'mdi-account-group', router: '/team' },
      { title: '엑셀자료', icon: 'mdi-file-excel', router: '/excel' },
    ],
    references: [
      { title: '한양도성타임머신', avatar: '/img/time-machine.png', href: 'http://dh.aks.ac.kr/hanyang2/wiki/index.php/%EB%8C%80%EB%AC%B8'},
      { title: '한국민족문화대백과사전', avatar: '/img//korean-culture.png', href: 'http://encykorea.aks.ac.kr'},
      { title: '두산백과', avatar: '/img/doopedia.png', href: 'https://www.doopedia.co.kr/'},
      { title: '위키백과', avatar: '/img/wikipedia.png', href: 'https://ko.wikipedia.org/wiki/%EC%9C%84%ED%82%A4%EB%B0%B1%EA%B3%BC:%EB%8C%80%EB%AC%B8'},
      { title: '네이버 지식백과', avatar: '/img/naver.jpg', href: 'https://terms.naver.com/' },
      { title: '문화콘텐츠닷컴', avatar: '/img/kocca.png', href: 'https://www.culturecontent.com/main.do'},
      { title: '조선왕조실록', avatar: '/img/sillokaks.png', href: 'http://sillok.history.go.kr/main/main.do'},
      { title: '위키실록사전', avatar: '/img/wikisillok.png', href: 'http://dh.aks.ac.kr/sillokwiki/index.php/%EB%8C%80%EB%AC%B8'},
      { title: '우리역사넷', avatar: '/img/history.jpg', href: 'http://contents.history.go.kr/front'},
      { title: '디지털장서각', avatar: '/img/jsg.png', href: 'http://jsg.aks.ac.kr/'},
      { title: '규장각원문검색서비스', avatar: '/img/kyudb.jpg', href: 'https://kyudb.snu.ac.kr/index.jsp'},
      { title: 'KCI', avatar: '/img/kci.png', href: 'https://www.kci.go.kr/kciportal/main.kci'},
      { title: 'DBpia', avatar: '/img/dbpia.png', href: 'https://www.dbpia.co.kr/'},
      { title: 'RISS', avatar: '/img/riss.png', href: 'http://www.riss.kr/index.do'},
      { title: '네이버 학술정보', avatar: '/img/naver.jpg', href: 'https://academic.naver.com/'},
      { title: 'KISS', avatar: '/img/kiss.png', href: 'https://kiss.kstudy.com/'},
      { title: 'URL Decoder/Encoder', avatar: '/img/url.png', href: 'https://meyerweb.com/eric/tools/dencoder/'},
    ]
  }),
  methods: {
    logout(){
      auth.signOut().then(() => {
        this.$router.push({ name: 'Login'})
      })      
    }
  },
  mounted(){
    auth.onAuthStateChanged(user => {
      if(user) {
        db.collection('users').where('id', '==', user.uid).get()
          .then(snapshot => {
            return snapshot.forEach(doc => {
              user.name = doc.data().name
              user.alias = doc.data().alias
              this.user = user
            })
          })
      } else {
        this.user = null
      }
    })
  }
};
</script>

<style>
a {
  text-decoration: none;
}
</style>
